"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChariotResource_1 = require("./ChariotResource");
var api_1 = require("../api");
var graphql_request_1 = require("graphql-request");
var class_transformer_1 = require("class-transformer");
var Errors_1 = require("../../helpers/Errors");
var Rule = /** @class */ (function (_super) {
    __extends(Rule, _super);
    function Rule(apiRule, chariot) {
        var _this = _super.call(this, apiRule, chariot) || this;
        _this._ = (0, class_transformer_1.plainToClass)(api_1.ApiRule, apiRule);
        return _this;
    }
    Rule.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body, apiRule, response, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, this.chariot.verifyWriteAccess()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.validateApiResource()];
                    case 2:
                        _a.sent();
                        body = this._;
                        apiRule = void 0;
                        if (!this._.id) return [3 /*break*/, 4];
                        delete body.owner;
                        delete body.client_id;
                        return [4 /*yield*/, this.chariot.GraphQL.request({
                                query: (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            mutation updateRule($updatePayload: UpdateRuleInput!) {\n              updateRule(input: $updatePayload) ", "\n            }\n          "], ["\n            mutation updateRule($updatePayload: UpdateRuleInput!) {\n              updateRule(input: $updatePayload) ", "\n            }\n          "])), this.chariot.Rule.defaultSelectionSet),
                                variables: {
                                    updatePayload: body
                                }
                            })];
                    case 3:
                        response = (_a.sent()).updateRule;
                        this.chariot.logger.log("Rule successfully updated");
                        apiRule = response;
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.chariot.GraphQL.request({
                            query: (0, graphql_request_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            mutation createRule($createPayload: CreateRuleInput!) {\n              createRule(input: $createPayload) ", "\n            }\n          "], ["\n            mutation createRule($createPayload: CreateRuleInput!) {\n              createRule(input: $createPayload) ", "\n            }\n          "])), this.chariot.Rule.defaultSelectionSet),
                            variables: {
                                createPayload: body
                            }
                        })];
                    case 5:
                        response = (_a.sent()).createRule;
                        this.chariot.logger.log("Rule successfully created");
                        apiRule = response;
                        _a.label = 6;
                    case 6:
                        this._ = (0, class_transformer_1.plainToClass)(api_1.ApiRule, apiRule);
                        return [2 /*return*/, this];
                    case 7:
                        e_1 = _a.sent();
                        this.chariot.logger.catch(e_1, "Failed to save rule");
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Rule.prototype.update = function (apiRule) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._ = (0, class_transformer_1.plainToClassFromExist)(this._, apiRule);
                        return [4 /*yield*/, this.save()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Rule.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.chariot.verifyWriteAccess()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chariot.GraphQL.request({
                                query: (0, graphql_request_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          mutation deleteRule($ruleId: String!) {\n            deleteRule(id: $ruleId) { id }\n          }\n        "], ["\n          mutation deleteRule($ruleId: String!) {\n            deleteRule(id: $ruleId) { id }\n          }\n        "]))),
                                variables: {
                                    ruleId: this._.id
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.chariot.Rule.__removeFromCache(this);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.chariot.logger.catch(e_2, "Failed to delete rule");
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Rule.prototype.getEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ruleEvents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve rule events for a site that does not exist. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.RuleEvent.list({
                                filters: {
                                    rule_id: this._.id
                                }
                            })];
                    case 1:
                        ruleEvents = _a.sent();
                        return [2 /*return*/, ruleEvents];
                }
            });
        });
    };
    return Rule;
}(ChariotResource_1.GraphEnabledChariotResource));
exports.default = Rule;
var templateObject_1, templateObject_2, templateObject_3;
